import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import type { TrpcRouter } from '@strength/trpc-server';

export const trpc: CreateTRPCReact<TrpcRouter, unknown, null> =
  createTRPCReact<TrpcRouter>();
